import { useEffect } from "react";

const BASE = "Countet Ops";

export function useDocumentTitle(title: string | null | undefined) {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title} · ${BASE}` : BASE;
    return () => {
      document.title = prev;
    };
  }, [title]);
}
